import React from "react";
import GridShape from "../../components/common/GridShape";
import { Link } from "react-router";
import { LayoutGrid, BarChart3, Users, ShieldCheck } from "lucide-react";

export default function AuthLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="relative min-h-screen bg-white z-1 dark:bg-gray-900 overflow-hidden">
      <div className="relative flex flex-col lg:flex-row min-h-screen">
        {/* Lado del Formulario */}
        <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-white dark:bg-gray-900 z-10">
          {children}
        </div>

        {/* Panel Visual Premium */}
        <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden bg-[#0F172A]">
          {/* Fondos Decorativos */}
          <div className="absolute inset-0 z-0">
            <div className="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] bg-indigo-600/20 rounded-full blur-[120px] animate-pulse"></div>
            <div className="absolute bottom-[-10%] left-[-10%] w-[400px] h-[400px] bg-purple-600/20 rounded-full blur-[100px] animate-pulse"></div>
            <div className="absolute inset-0 opacity-10">
              <GridShape />
            </div>
          </div>

          <div className="relative z-10 w-full flex flex-col items-center justify-center p-12 text-white">
            {/* Logo con brillo */}
            <div className="mb-12 relative group">
              <div className="absolute -inset-1 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-lg blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>
              <Link to="/" className="relative block">
                <img
                  style={{ width: "280px" }}
                  src="/logo.png"
                  alt="Logo"
                  className="brightness-0 invert transition-transform duration-500 group-hover:scale-105"
                />
              </Link>
            </div>

            {/* Texto Principal */}
            <div className="max-w-md text-center mb-12">
              <h2 className="text-4xl font-extrabold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-white to-indigo-200">
                Gestion Inteligente de Proyectos
              </h2>
              <p className="text-indigo-100/80 text-lg leading-relaxed">
                Potencia la productividad de tu empresa con nuestra solucion integral de administracion multi-cliente.
              </p>
            </div>

            {/* Cards de Caracteristicas (Efecto Glassmorphism) */}
            <div className="grid grid-cols-2 gap-4 w-full max-w-lg">
              <div className="p-4 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-md hover:bg-white/10 transition-colors">
                <LayoutGrid className="w-8 h-8 text-indigo-400 mb-3" />
                <h3 className="font-bold text-sm mb-1">Multi-Empresa</h3>
                <p className="text-xs text-indigo-200/60">Control total centralizado</p>
              </div>
              <div className="p-4 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-md hover:bg-white/10 transition-colors">
                <BarChart3 className="w-8 h-8 text-emerald-400 mb-3" />
                <h3 className="font-bold text-sm mb-1">Analiticas</h3>
                <p className="text-xs text-indigo-200/60">Metricas en tiempo real</p>
              </div>
              <div className="p-4 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-md hover:bg-white/10 transition-colors">
                <Users className="w-8 h-8 text-purple-400 mb-3" />
                <h3 className="font-bold text-sm mb-1">Equipos</h3>
                <p className="text-xs text-indigo-200/60">Colaboracion fluida</p>
              </div>
              <div className="p-4 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-md hover:bg-white/10 transition-colors">
                <ShieldCheck className="w-8 h-8 text-blue-400 mb-3" />
                <h3 className="font-bold text-sm mb-1">Seguridad</h3>
                <p className="text-xs text-indigo-200/60">Proteccion nivel enterprise</p>
              </div>
            </div>

            {/* Decoracion inferior */}
            <div className="mt-16 pt-8 border-t border-white/5 w-full text-center">
              <p className="text-sm text-indigo-300/40">
                &copy; 2026 Futurum Project. Todos los derechos reservados.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
